<template>
  <div class="base-button text-align">
    <v-btn
      v-bind="$attrs"
      rounded
      color="white"
      :class="getAppName()"
      @click.native="$emit('click')"
    >
      <slot></slot>
    </v-btn>
  </div>
</template>

<script>
import { appIdentifier } from "@/utils/appIdentifier.js";

export default {
  name: "BaseButton",
  inheritAttrs: false,
  props: {},
  methods: {
    getAppName() {
      return appIdentifier();
    }
  }
};
</script>

<style lang="scss" scoped>
.base-button {
  height: 50px;

  button {
    width: 100%;
    height: 100% !important;
    font-family: AWConquerorCarved-One;
    font-size: 1.7rem;
    color: var(--v-brand-base) !important;

    &.canals5D {
      color: white !important;
      background: #213e52 !important;
    }
  }
}
</style>
